import React, { ReactNode } from "react";
import { ConfirmIcon, StageStateIcon, StateIcon } from "components";
import { StageState, UpdateState } from "enums";
import { IStage, IUpdate } from "interfaces";

export function renderIcon(update: IUpdate, stage: IStage): ReactNode {
    const iconClass = 'calendarUpdateEvent_stateIcon'
    if (stage.state === StageState.Scheduled && stage.requiresConfirmation && !stage.isConfirmed) {
        return <ConfirmIcon isConfirmed={false} className={iconClass} />
    } 
    
    if (update.state >= UpdateState.Running) {
        return <StageStateIcon state={stage.state} className={iconClass} />
    } 
    
    return <StateIcon state={update.state} className={iconClass} />
}